import { render, staticRenderFns } from "./ManagePriceAdjustments.vue?vue&type=template&id=4fc24b38"
import script from "./ManagePriceAdjustments.vue?vue&type=script&lang=js"
export * from "./ManagePriceAdjustments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports